var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"loading":_vm.loading,"headers":_vm.headers,"items":_vm.data,"item-class":_vm.row_classes,"sort-by":"plannedDeparture","item-key":"rideId","clickable":""},on:{"click:row":_vm.onRowSelect},scopedSlots:_vm._u([{key:"item.plannedDeparture",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.tConvert(item.plannedDeparture))))+" ")]}},{key:"item.actualDeparture",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.tConvert(_vm.getFirstStopDepratTime(item.extraDetails.rideStops)))))+" ")]}},{key:"item.plannedArrival",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.tConvert(item.plannedArrival))))+" ")]}},{key:"item.actualArrival",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.tConvert(item.actualArrival))))+" ")]}},{key:"item.booked",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (parseInt(item.boardedPassengers) + parseInt(item.nonBoardedPassengers))))+" ")]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }